"use client";

import type { CSSProperties } from "react";
import { X } from "lucide-react";

/**
 * The landing's error notice, on desktop and phone alike: the message, then a
 * Dismiss button that is a full 44px touch target. The caller places it
 * (`className`, `style`) and gives the Dismiss label already translated.
 */
export function LandingErrorBanner({ message, onDismiss, dismissLabel, className = "", style }: {
  message: string;
  onDismiss: () => void;
  dismissLabel: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`flex items-center gap-2 rounded-lg border border-red-400/40 bg-red-950/85 py-1 pl-4 pr-1 text-xs text-red-100 backdrop-blur-sm ${className}`}
      style={style}
    >
      <span className="min-w-0 flex-1 py-1">{message}</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label={dismissLabel}
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-red-100/70 transition-colors hover:bg-red-400/15 hover:text-red-50 active:bg-red-400/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-200"
      >
        <X aria-hidden="true" className="h-4 w-4" />
      </button>
    </div>
  );
}
